/**
 * Color tokens for the Travo "postmark" theme.
 * Taken from the Window Seat icon: ink outline, envelope cream, periwinkle sky, sun.
 */

export const colors = {
  ink: { value: '#2B2A33' },
  inkSoft: { value: '#4A4740' },
  muted: { value: '#5E5A52' },
  paper: { value: '#F6EEDC' },
  card: { value: '#FFFDF7' },
  sand: { value: '#E9DFC6' },
  // UI accent: #667EEA fails 4.5:1 under white text, so buttons use this deeper stamp blue
  stamp: { value: '#4F5FE5' },
  stampDeep: { value: '#3B47D0' },
  periwinkle: { value: '#667EEA' },
  plum: { value: '#764BA2' },
  sun: { value: '#F2A93B' },
  sky: { value: '#B9C5F6' },
  rust: { value: '#B4532A' }
} as const;
